import { SelMessage } from "@selector/shared/components";
import type { FC, ReactNode } from "react";
import { Card, CardSection, type GridCard } from "widgets";

import type { Gene } from "@/graphql.ts";

import { GeneInfo } from "./GeneCard.js";

export interface IGenesCardProps extends GridCard {
  genes: Gene[];
  title?: string;
}

const GenesCard: FC<IGenesCardProps> = (props) => {
  const genes: Gene[] = props.genes;
  if (!genes) {
    return null;
  }

  let elements: ReactNode = <SelMessage id={"noContent.parentGenes"} />;

  if (genes && genes.length > 0) {
    elements = genes.map((gene: Gene) => (
      <CardSection title={gene.name} key={gene.name}>
        <GeneInfo gene={gene} />
      </CardSection>
    ));
  }

  return (
    <Card title={props.title ?? "Parent Genes"} tag={{ label: String(genes.length) }}>
      {elements}
    </Card>
  );
};

export { GenesCard };
